module.exports = __webpack_public_path__ + "img/en_lkw_a.477fae22.jpg";